if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  // Make the required terms checkbox clearly visible for all shoppers,
  // including people with color-vision deficiencies and keyboard users.
  const ensureAccessibleTermsCheckbox = () => {
    const styleId = 'liora-accessible-cart-terms';
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #x-cart-agree {
        width: 20px !important;
        height: 20px !important;
        min-width: 20px !important;
        flex: 0 0 20px !important;
        border: 2px solid #1f201f !important;
        background-color: #ffffff !important;
        opacity: 1 !important;
        box-shadow: none !important;
      }

      #x-cart-agree:checked {
        background-color: #282928 !important;
        border-color: #282928 !important;
      }

      #x-cart-agree:checked::after {
        border-color: #ffffff !important;
      }

      #x-cart-agree:focus-visible {
        outline: 3px solid #000000 !important;
        outline-offset: 2px !important;
      }

      label[for="x-cart-agree"] {
        line-height: 1.4 !important;
        min-height: 44px !important;
        display: flex !important;
        align-items: center !important;
      }
    `;
    document.head.appendChild(style);
  };

  ensureAccessibleTermsCheckbox();

  // The return-policy acknowledgement must be made during the current visit.
  // Keep it in memory only so a previous visit can never pre-check the box.
  window.__lioraReturnPolicyAgreed = false;

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (cartToken) => ({
        cartToken: cartToken || 'cart',
        checked: false,
        showError: false,
        storageKey() {
          return `liora_return_policy_${this.cartToken}`;
        },
        init() {
          // Remove any agreement saved by the previous implementation.
          localStorage.removeItem(this.storageKey());
          this.checked = false;
          this.showError = false;

          this.$watch('checked', (value) => {
            window.__lioraReturnPolicyAgreed = value === true;
            if (value === true) this.showError = false;
            this.save();
          });

          document.addEventListener('eurus:cart:validate', () => {
            if (window.__lioraReturnPolicyAgreed !== true) {
              this.showError = true;
              Alpine.store('xCartHelper').validated = false;
            }
          });
        },
        save() {
          const status = this.checked ? 'agreed' : 'not agreed';
          Alpine.store('xCartHelper').updateCart({
            attributes: {
              'Terms and conditions': status
            }
          });
        }
      }));
    });
  });
}
